import {commonService} from "./common.services";

export  const galleryService = {
    getAllGallery,
    saveGallery,
    trackDownload,
    countVGallery,
    deleteFile
}

function getAllGallery(data) {

    return commonService.sendHttpRequest('rbuilder/loadgallery', data, "POST");
}

function saveGallery(data) {

    return commonService.sendHttpRequest('rbuilder/savegallery', data, "POST");
}

function trackDownload(data) {

    return commonService.sendHttpRequest('rbuilder/trackdownload', data, "POST");
}
function countVGallery(data) {

    return commonService.sendHttpRequest('vgallery/assetgallerydetails', data, "GET");
}
function deleteFile(data) {

    return commonService.sendHttpRequest('vgallery/assetgallerydelete', data, "POST");
}


// WEBPACK FOOTER //
// ./src/services/gallery.services.js